<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <img ref="homeBanner" src="../../../assets/img/partnersBanner.jpg" />
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->
      </div>
    </div>
    <div class="partnersContent" id="m1">
      <div
        class="contentW animated"
        :class="animates.mm1 ? 'fadeInUp' : 'hideBox'"
      >
        <div class="paytype">Payment solutions</div>
        <div class="titleBox">
          <ul class="logoUl">
            <li>
              <img
                src="../../../assets/icon/unipay.png"
                width="95px"
                height="60px"
              />
            </li>
            <li>
              <img
                src="../../../assets/icon/WHCHATPAY.png"
                width="207px"
                height="60px"
              />
            </li>
            <li>
              <img
                src="../../../assets/icon/alipaylogo.png"
                width="191px"
                height="60px"
              />
            </li>
          </ul>
        </div>
        <div class="bt-line"></div>
        <div class="paytype">POS integration solutions</div>
        <div class="titleBox">Blueshyft</div>
        <div class="textBox">
          Blueshyft is an iOS-based counter-top platform installed in 1200+
          retail locations, connecting online businesses to 2.5 million
          potential customers each day. Retail locations are supplied with
          blueshift‘s tech platform set up on a secure iPad, featuring live API
          connections to client systems. With lightning fast integrations,
          clients can start selling their digital products through the network
          in a flash.
        </div>
        <div class="titleBox">Futura Retail Solutions</div>
        <div class="textBox">
          Futura Retail Solutions specialises in point of sale and inventory
          management software designed for fashion, speciality and general
          merchandise retailers. With an extensive suite of POS, merchandise,
          inventory and end- to-end retail software, Futura4Retail has been
          powering retailers for over 40 years.
        </div>
        <div class="titleBox">IPOS</div>
        <div class="textBox">
          IPOS is committed to assist creating business growth by delivering
          tailor-made point of sales (POS) systems and excellent customer
          services for retail and hospitality enterprises. With over 2000 loyal
          customers on board since establishment, they are one of the most
          popular POS systems providers across major capital cities in
          Australia.
        </div>
        <div class="titleBox">PosPal</div>
        <div class="textBox">
          PosPal is the new-generation cashier software independently developed
          by Zhundong Network (Xiamen) Co., Ltd (“Zhundong”). It employs the
          cloud technology, which is amongst the most stable cashier software
          based on cloud architecture in China, as well as the earliest batch of
          cashier software that realized real-time connection with the mobile
          network. It is highly compatible and supports most mainstream
          equipment, integrating various payments to satisfy different user
          demands.
        </div>
        <!-- <div class="titleBox">CLPS</div>
        <div class="textBox">
          Founded in 2005 as an early entrant to China IT service sector, CLPS
          is a customer-based service provider focused on delivering services to
          global institutions in banking, insurance and financial sectors, both
          in China and globally. SuperiorPay worked with CLPS and created Q
          Bill, the smart bill payment product enabling QR Code payment method
          of bills in Australia.
        </div> -->
        <div class="titleBox">Grand View Technology</div>
        <div class="textBox">
          Shenzhen Qiongjing Technology Co., Ltd. (Grand View Technology),
          specializing in Australia-China cross-border trade services, is a
          professional Australian-Chinese cross-border S2B platform. Full-link
          one-stop supply and marketing system “Astraea” provides Australian
          brands, manufacturers, distributors, and Chinese sellers, third- party
          platforms, distributors, and consumers with SaaS service for offshore
          transactions.
        </div>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
  <!--</div>-->
</template>

<script>
import topNav from "./nav";
import Footer from "@/components/Footer"
let timer = null; //定义初始值
export default {
  name: "Partners",
  components: { topNav,Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      animates: {
        mm1: false,
      },
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;

    this.animates.mm1 = true;
  },
  methods: {
    //置顶
    toTop() {
      // 动画

      timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    navClick2(url) {
      this.$router.push(url);
    }
  },
};
</script>

<style scoped>
body {
  min-width: 1345px;
}

.partnersMain {
  width: 100%;
  height: auto;
}
.partnersMain .bannerBox {
  width: 100%;
  height: auto;
  position: relative;
}
.partnersMain .bannerBox > img {
  width: 100%;
}
.partnersMain .bannerBox .topTextBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.partnersMain .bannerBox .topTextBox .bannerText1 {
  height: 7rem;
  text-align: center;
  margin-top: 12%;
}
.partnersMain .bannerBox .topTextBox .bannerText1 > img {
  width: 14rem;
}

/*内容部分*/
.partnersContent {
  width: 100%;
  height: auto;
  padding: 5rem 0 10rem 0;
  background-color: #fff;
}
.partnersContent .titleBox {
  width: 70%;
  margin: 3rem auto 1rem auto;
  line-height: 2rem;
  font-family: OpenSans300;
  color: #000;
  font-size: 1.5rem;
}
.partnersContent .textBox {
  width: 70%;
  margin: 1rem auto;
  line-height: 1.5rem;
  padding: 1rem 0;
  font-family: MontserratRegular;
  color: #4a4a4a;
  font-size: 0.875rem;
}

.hideBox {
  display: none;
}
.titleBox .logoUl {
  width: 100%;
  height: 4rem;
}
.titleBox .logoUl > li {
  float: left;
  width: 33.3%;
  height: 100%;
  display: flex;
  align-items: center;
}
.titleBox .logoUl > li > img {
  align-items: center;
  margin: auto;
}
.paytype {
  width: 70%;
  margin: 1rem auto;
  line-height: 1.5rem;
  padding: 1rem 0;
  font-family: PingFangMedium;
  color: #4a4a4a;
  font-size: 2rem;
}
.bt-line {
  border: rgba(134, 131, 131, 0.466) solid 1px;
  margin: 80px auto;
  width: 70%;
}

.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
